import React from "react";
import {FormatedPrice,BtnItemBlockInfo} from "@gull";
import {Type} from 'react-bootstrap-table2-editor';

// wmsid : id de section courante (WMS ou POS via posid) pour afficher le stock dans la modal ;
// omis/undefined hors contexte section (ERP, Facturation) pour un stock "toutes sections".
const articleDataGenerator = (obj, article,t,wmsid) => {

    obj.internalid = article.internalid;
    obj.marque = (article.marque) ? article.marque.name : '-';
    obj.fournisseur = (article.fournisseur) ? article.fournisseur.name : '-';
    obj.provisoire  = (article.provisoire == 0) ? t('btnNo') : t('btnYes');
    obj.havestock = (article.havestock) ? t('yes') :  t('no');
    obj.to_prepare = (article.to_prepare) ? t('yes') :  t('no');
    obj.name = article.name;
    obj.sku = article.sku;
    obj.parent_name = article.parent_name;
    obj.reference = (article.reference) ? article.reference : '';
    obj.reference2 = (article.reference2) ? article.reference2 : '';
    obj.image = (article.image!=null) ? <BtnItemBlockInfo articleId={article.id} image={article.image} articleName={article.name} wmsid={wmsid} /> : '';
    // obj.pr = article.pr;
    obj.margeN  = (article.ht!=null && article.ht!=0) ? article.ht-article.prmp : 0;
    obj.margeP  = (article.ht!=null && article.ht!=0) ? Math.round((article.ht-article.prmp)/article.ht*100) : 0;
    obj.tgc = article.tgc;
    obj.article_id = article.id;
    obj.prmp  = article.prmp;
    obj.ht  = article.ht;
    obj.price = article.price;
    obj.price_b2b = article.price_b2b!=null ? article.price_b2b : '';
    obj.ttcb2b = article.price_b2b_ttc!=null ? article.price_b2b_ttc : '';
    obj.margeNB2b  = (article.price_b2b!==null) ? article.price_b2b-article.prmp : '';
    obj.margePB2b  = (article.price_b2b!=null && article.price_b2b!=0) ? Math.round((article.price_b2b-article.prmp)/article.price_b2b*100) : 0;
    obj.firstlevelcat = article.firstlevelcat && article.firstlevelcat.name != null ? article.firstlevelcat.name : '';
    obj.secondlevelcat = article.secondlevelcat && article.secondlevelcat.name != null ? article.secondlevelcat.name : '';
    obj.thirdlevelcat = article.thirdlevelcat && article.thirdlevelcat.name != null ? article.thirdlevelcat.name : '';
    obj.fourthlevelcat = article.fourthlevelcat && article.fourthlevelcat.name != null ? article.fourthlevelcat.name : '';
    obj.fifthlevelcat = article.fifthlevelcat && article.fifthlevelcat.name != null ? article.fifthlevelcat.name : '';
    obj.archive = article.archive;
    obj.archived = (article.archive) ? t('yes') : t('no');
    obj.categorie_douane = article.categorie_douane!=null ? article.categorie_douane : '';
    obj.ecotaxe = article.ecotaxe!=null ? article.ecotaxe : '';
    obj.last_date_buy = article.last_date_buy!=null ? article.last_date_buy : '';
    obj.first_stock_entry_date = article.first_stock_entry_date!=null ? article.first_stock_entry_date : '';
    obj.last_pr = article.last_pr!=null ? article.last_pr : '';
    obj.last_buy_price = article.last_buy_price!==null ? article.last_buy_price : '';
    obj.last_buy_price_devise = article.last_buy_price_devise!==null ? article.last_buy_price_devise : '';
    obj.last_devise = article.last_devise!==null ? article.last_devise : '';
    obj.position = article.position!=null ? article.position : '';
    obj.unit = article.unit!=null ? article.unit : '';
    obj.weight = article.weight!=null ? article.weight : '';
    obj.price_unit = article.price_unit!=null ? article.price_unit : '';
    obj.price_unit_b2b = article.price_unit_b2b!=null ? article.price_unit_b2b : '';
    obj.minimum_commande = article.minimum_commande!=null ? article.minimum_commande : '';
    obj.default_conditionnement = (article.default_conditionnement_id != null) ? article.default_conditionnement_id : '';
    // Edition conditionnement par defaut via datatable
    obj.enumere_conditionnement=[{ value: '', label: '' },...((article.enumere_conditionnement ?? []).map(c => ({value: c.id,label: c.name})))];
    obj.our_enumere_conditionnement = Object.fromEntries((obj.enumere_conditionnement ?? []).map(o => [o.value, o.value]));
};

export default articleDataGenerator;